export var CustomizeStep;
(function (CustomizeStep) {
    CustomizeStep[CustomizeStep["ChooseProductSpec"] = 1] = "ChooseProductSpec";
    CustomizeStep[CustomizeStep["ChooseSpec"] = 2] = "ChooseSpec";
    CustomizeStep[CustomizeStep["ChooseAddon"] = 3] = "ChooseAddon";
    CustomizeStep[CustomizeStep["ChooseImprint"] = 4] = "ChooseImprint";
    CustomizeStep[CustomizeStep["ChooseDropShip"] = 5] = "ChooseDropShip";
    CustomizeStep[CustomizeStep["ChooseProducttiomTime"] = 6] = "ChooseProducttiomTime";
})(CustomizeStep || (CustomizeStep = {}));
export var OrderType;
(function (OrderType) {
    OrderType[OrderType["Normal"] = 0] = "Normal";
    OrderType[OrderType["SpecSample"] = 1] = "SpecSample";
})(OrderType || (OrderType = {}));
